import api from './api';

export interface EducationEntry {
  id: number;
  entryType: 'UNIVERSITY_DEGREE' | 'PRE_UNIVERSITY';
  // UNIVERSITY_DEGREE fields
  universityName?: string;
  subjectStudied?: string;
  // PRE_UNIVERSITY fields
  collegeName?: string;
  courseName?: string;
  subjects?: string;
  // Shared
  city: string;
  country: string;
  yearOfCompletion: number;
  displayOrder: number;
  createdAt: string;
}

export interface EducationEntryRequest {
  entryType: 'UNIVERSITY_DEGREE' | 'PRE_UNIVERSITY';
  universityName?: string;
  subjectStudied?: string;
  collegeName?: string;
  courseName?: string;
  subjects?: string;
  city: string;
  country: string;
  yearOfCompletion: number;
  displayOrder?: number;
}

class UserEducationService {
  async getEducationEntries(): Promise<EducationEntry[]> {
    const response = await api.get('/api/users/education');
    return response.data.data;
  }

  async addEducationEntry(request: EducationEntryRequest): Promise<EducationEntry> {
    const response = await api.post('/api/users/education', request);
    return response.data.data;
  }

  async updateEducationEntry(id: number, request: Partial<EducationEntryRequest>): Promise<EducationEntry> {
    const response = await api.put(`/api/users/education/${id}`, request);
    return response.data.data;
  }

  async deleteEducationEntry(id: number): Promise<void> {
    await api.delete(`/api/users/education/${id}`);
  }
}

export const userEducationService = new UserEducationService();
